<template>
    <div>
        <h1>Отправка Отчетов</h1>
        <p>В разделе «Отправка отчётов» вы можете настроить, кому, когда и какие отчёты с информацией по вашему проекту будут автоматически отправляться.</p>
        <h2 >Добавление отчета</h2>
        <p>Для того чтобы добавить отчёт на проект, нажмите на кнопку <strong>Добавить отчёт</strong>.</p>
        <p>
            <span class="img-wrapper">
                <v-progress-circular v-if="!loadedImages[0]" indeterminate color="mainNew" class="img-loader" />
                <img src="https://dataheroes.platrum.ru/wiki/api/article/file?file_id=0e2d95bb81d9ef0c129ce25d471e93d6&article_id=5328" alt="img" :class="{ 'img-loaded': loadedImages[0] }" style="width:100%;" @load="onImageLoad(0)" />
            </span>
        </p>
        <p>После нажатия откроется страница настройки отчёта. Для создания отчёта необходимо последовательно пройти по 5 блокам настройки.</p>
        <ol>
            <li>
                Введите название для отчёта. Кнопка <strong>Сохранить</strong> в углу блока 1 станет активной — нажмите её для перехода к следующему блоку.
                <span class="img-wrapper">
                    <v-progress-circular v-if="!loadedImages[1]" indeterminate color="mainNew" class="img-loader" />
                    <img src="https://dataheroes.platrum.ru/wiki/api/article/file?file_id=e1aa7dfca2d407ffdd9af0d63ad52161&article_id=5328" alt="img" :class="{ 'img-loaded': loadedImages[1] }" style="width:100%;" @load="onImageLoad(1)" />
                </span>
            </li>
            <li>Выберите интересующий вас шаблон отчёта и нажмите <strong>Сохранить</strong>. Некоторые шаблоны требуют указать норму — например, «Еженедельный отчёт» требует ввести значение плана звонков на неделю. Описание каждого шаблона и примеры отчётов — есть в нашей <a href='https://dataheroes.platrum.ru/help?slug=4790-otpravka-otchetov-kopiya'>базе знаний</a>.</li>
            <li>Выберите канал отправки, через который будет осуществляться отправка отчёта, и нажмите <strong>Сохранить</strong> в углу блока 3.</li>
            <li>Укажите контакты получателей отчёта и нажмите <strong>Сохранить</strong> в углу блока 4.</li>
            <li>
                Выберите часовой пояс и время отправки. Галочку <strong>Присылать отчёт за прошлый день</strong> ставить не обязательно, но рекомендуем использовать её, если данные заполняются салоном вечером. Нажмите <strong>Сохранить</strong> в углу блока 5 — блок свернётся, общая кнопка <strong>Сохранить</strong> вверху страницы станет активной.
                <span class="img-wrapper">
                    <v-progress-circular v-if="!loadedImages[2]" indeterminate color="mainNew" class="img-loader" />
                    <img src="https://dataheroes.platrum.ru/wiki/api/article/file?file_id=7868f9517fd1ecd4424ddb1022e24443&article_id=5328" alt="img" :class="{ 'img-loaded': loadedImages[2] }" style="width:100%;" @load="onImageLoad(2)" />
                </span>
            </li>
        </ol>
        <p>Нажмите общую кнопку <strong>Сохранить</strong> — вы вернётесь на главную страницу. Отчёт создан и отображается в списке отчётов.</p>
        <p>
            <span class="img-wrapper">
                <v-progress-circular v-if="!loadedImages[3]" indeterminate color="mainNew" class="img-loader" />
                <img src="https://dataheroes.platrum.ru/wiki/api/article/file?file_id=2b7860d65c52a325bdad63ce41c144ba&article_id=5328" alt="img" :class="{ 'img-loaded': loadedImages[3] }" style="width:100%;" @load="onImageLoad(3)" />
            </span>
        </p>
        <h2>Редактирование отчёта</h2>
        <p>Для редактирования отчёта нажмите на строке с отчётом на кнопку контекстного меню в виде трёх вертикальных точек «⋮». В раскрывшемся меню выберите <strong>Редактировать</strong>.</p>
        <p>
            <span class="img-wrapper">
                <v-progress-circular v-if="!loadedImages[4]" indeterminate color="mainNew" class="img-loader" />
                <img src="https://dataheroes.platrum.ru/wiki/api/article/file?file_id=1d6823706c014e5b890f63407c097ec6&article_id=5328" alt="img" :class="{ 'img-loaded': loadedImages[4] }" style="width:100%;" @load="onImageLoad(4)" />
            </span>
        </p>
        <p>Измените настройки в нужных блоках и нажмите кнопку <strong>Сохранить</strong>.</p>
        <p><strong><u>Важно!</u></strong> Изменить шаблон в созданном отчете нельзя. Если вам нужен отчет с другим шаблоном, то создайте новый.</p>
        <h2>Удаление отчёта</h2>
        <p>Для того чтобы удалить отчёт, нажмите на строке с отчётом на кнопку контекстного меню в виде трёх вертикальных точек «⋮». В раскрывшемся меню выберите <strong>Удалить</strong></p>
        <p>
            <span class="img-wrapper">
                <v-progress-circular v-if="!loadedImages[5]" indeterminate color="mainNew" class="img-loader" />
                <img src="https://dataheroes.platrum.ru/wiki/api/article/file?file_id=b2fe854133aa75e75de14fcae563e632&article_id=5328" alt="img" :class="{ 'img-loaded': loadedImages[5] }" style="width:100%;" @load="onImageLoad(5)" />
            </span>
        </p>
        <p><strong><u>Важно!</u></strong> Если вы не можете удалить/редактировать отчет, то значит у вас недостаточно прав для этих действий. Ознакомиться с ролями системы можно по <a href='https://dataheroes.platrum.ru/help?slug=4760-gibkaya-nastrojka-prav-dostupa-kopiya'>ссылке</a>.</p>
    </div>
</template>

<script>
//hintId  <scheduledReport>
export default {
    name: 'ScheduledReportHint',
    computed: {},
    components: {},
    data: () => ({
        loadedImages: { 0: false, 1: false, 2: false, 3: false, 4: false, 5: false },
    }),
    methods: {
        onImageLoad(index) {
            this.$set(this.loadedImages, index, true)
        },
    },
    mounted() {},
}
</script>



<style lang="sass" scoped>
@import '@/vars.sass'
p
    font-size: 14px

.img-wrapper
    display: block
    position: relative
    min-height: 80px

.img-loader
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)

.img-wrapper img
    opacity: 0
    transition: opacity 0.3s ease

.img-wrapper img.img-loaded
    opacity: 1
</style>
